/* eslint-disable */
import React, {useState, useRef, useEffect} from 'react'
const Icon = styled.img``;
import Svg from "_assets/svg";

// library
import styled from 'styled-components';
import Search from 'components/SearchV2';

// style
import './InputRightDropdown.scss';

function InputRightDropdown(props) {

  const {
    isListSearch, 
    setSelectedSearch, 
    isSelected, 
    placeholder, 
    className, 
    onChange, 
    valueInput, 
    customClass,
    typeInput,
    useSearch,
    sourceRegister
  } = props;
  // console.log('isSelected', isSelected)
  const [isShowListSearch, setShowListSearch] = useState(false)
  const [isSearch, setSearch] = useState('');
  const [timer, setTimer] = useState(null)
  const [isDataLooping, setDataLooping] = useState([])
  const container = useRef();

  console.log('isSelected',isSelected)
  function chooseSearchType(item){
    setSelectedSearch(item)
    setShowListSearch(false)
  }

  function handleClickSearch(){
    setShowListSearch(!isShowListSearch)
  }

  function handleSearch(e) {
    let key = e
    delayedQuery(key);
  }
  
  const delayedQuery = async (q) => {
    setSearch(q);
  
    clearTimeout(timer)
    
    const newTimer = setTimeout(async() => {

      if(q){
        // search manual not by get api
        const dataSearch = [];
        const upper = q.toUpperCase();
  
        for (let i = 0; i < isDataLooping.length; i++) {
          if (isDataLooping[i].name.toUpperCase().indexOf(upper) > -1) {
            dataSearch.push(isDataLooping[i]);
          }
        }
        if (dataSearch.length > 0) {
          setDataLooping(dataSearch);
        } else {
          setDataLooping([]);
        }
      }else{
        setDataLooping(isListSearch);
      }
      // changeCriteria({ page: 1, limit: 10});
      // setUpdatedChange(!isUpdatedChange)
    }, 500)
  
    setTimer(newTimer)
  }

  useEffect(()=>{
    setDataLooping(isListSearch)
  }, [isListSearch])

  useEffect(() => {
    function handleClickOutside(event) {
        if (container.current && !container.current.contains(event.target)) {
          setShowListSearch(false);
        }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [container])

  return (
    <div className="input_dropdown_right"  ref={container}>
    <div className="input-group">
      <input
        type={`${typeInput ? typeInput : 'text'}`}
        className={`${sourceRegister ? 'input_type w-75 cl-neutral400 fsize-14 fweight-400 form-control border-left mb-0' : 'input_type form-control cl-neutral400 fsize-14 fweight-400 border-left mb-0'}`}
        id="id"
        placeholder='Input here'
        value={valueInput}
        onChange={(e) => onChange(e.target.value)}
      />
      <div className={`
        ${sourceRegister ? 'w-25' : ''}
        ${className} 
        ${customClass === 'country_code' && customClass} 
        wrap_input_prepend form-control p-1`} onClick={handleClickSearch} ref={container}>
          <div className='selected'>
            <div className='d-flex align-items-center justify-content-between w-100'>
              {/* <Icon src={isSelected.img} alt={isSelected.img} width={20} /> */}
              <span className='cl-neutral500 fsize-14 fweight-400 mb-0'>
                {isSelected?.label ? isSelected.label : isSelected?.name ? isSelected?.name : placeholder}
              </span>
              <Icon src={Svg.chevron_right.default} className={`${isShowListSearch ? 'rotate_180' : 'rotate_0'}`}/>
            </div>
          </div>
      {isShowListSearch &&
        <div className='dropdown' >
          <div className='list_search'>
            {useSearch && 
              <Search 
                onChange={handleSearch} 
                value={isSearch} 
                placeholder="Search ..." 
                className="mb-2 px-2 mt-1"
                color="#7A869A"
                minWidth="100%"
              />
            }
            {isDataLooping.map((item, idx) =>{
              return <div key={idx} onClick={()=>chooseSearchType(item)} className='wrapp_list py-2 d-flex align-items-center'>
                <div className='d-flex flex-column'>
                  <span className='cl-neutral500 fsize-14 fweight-400 mb-1'>
                    {item.label}
                  </span>
                  <span className='cl-neutral500 fsize-14 fweight-400 mb-0'>
                    {item.name}
                  </span>
                </div>
              </div>
            })}
            {isDataLooping.length === 0 && <span className='fweight-400 fsize-14 cl-neutral100 mx-2'>No Result</span>}
          </div>
        </div>
      }
      </div>
    </div>
    </div>
  )
}

export default InputRightDropdown